// This file is auto-generated. Do not edit manually.
    import { PropertyType } from "@/app/[locale]/(public)/rent/[locationSlug]/_components/property-type/utils";
  export const rentPropertyTypes: Record<string, Partial<Record<PropertyType, number>>> = {
  "alkmaar": {
    "1-bedroom-apartment": 6,
    "2-bedroom-apartment": 8,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 7,
    "green-energy-apartment": 8,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 12
  },
  "almelo": {
    "family-house": 6,
    "house-for-rent": 6,
    "unfurnished-house": 6
  },
  "almere": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 6,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 11,
    "apartment-with-elevator": 8,
    "apartment-with-security": 5,
    "family-house": 11,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 11,
    "furnished-house": 7,
    "furnished-house-with-garden": 7,
    "furnished-room": 11,
    "green-energy-apartment": 14,
    "green-energy-house": 9,
    "green-energy-room": 8,
    "house-for-rent": 11,
    "house-with-garden": 11,
    "renovated-apartment": 5,
    "room-for-students": 14,
    "student-housing": 19,
    "unfurnished-apartment": 12,
    "unfurnished-room": 7
  },
  "alphen-aan-den-rijn": {
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 7,
    "green-energy-apartment": 7,
    "unfurnished-apartment": 8
  },
  "amersfoort": {
    "2-bedroom-apartment": 10,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "apartment-with-private-parking": 7,
    "family-house": 6,
    "furnished-house": 5,
    "furnished-house-with-garden": 5,
    "green-energy-apartment": 7,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 12
  },
  "amstelveen": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "3-bedroom-apartment": 7,
    "apartment-with-balcony": 13,
    "apartment-with-elevator": 7,
    "apartment-with-private-parking": 5,
    "family-house": 8,
    "furnished-apartment": 7,
    "furnished-room": 6,
    "green-energy-apartment": 16,
    "green-energy-house": 7,
    "green-energy-room": 5,
    "house-for-rent": 8,
    "house-with-garden": 6,
    "room-for-students": 10,
    "student-housing": 13,
    "unfurnished-apartment": 13,
    "unfurnished-house": 7,
    "unfurnished-room": 6
  },
  "amsterdam": {
    "1-bedroom-apartment": 137,
    "2-bedroom-apartment": 202,
    "2-bedroom-house": 6,
    "3-bedroom-apartment": 57,
    "3-bedroom-house": 7,
    "4-bedroom-apartment": 8,
    "apartment-with-balcony": 236,
    "apartment-with-elevator": 96,
    "apartment-with-garden": 44,
    "apartment-with-laundry": 23,
    "apartment-with-private-parking": 55,
    "apartment-with-security": 12,
    "family-house": 19,
    "flat-for-students": 103,
    "furnished-1-bedroom-apartment": 67,
    "furnished-apartment": 184,
    "furnished-house": 10,
    "furnished-room": 149,
    "furnished-studio": 27,
    "green-energy-apartment": 283,
    "green-energy-house": 11,
    "green-energy-room": 69,
    "green-energy-studio": 36,
    "house-for-rent": 21,
    "house-with-garden": 10,
    "newly-built-apartment": 8,
    "pet-friendly-apartment": 31,
    "renovated-apartment": 44,
    "room-for-students": 115,
    "room-with-laundry": 9,
    "student-housing": 221,
    "studio-for-rent": 51,
    "studio-with-balcony": 5,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 239,
    "unfurnished-house": 11,
    "unfurnished-room": 19,
    "unfurnished-studio": 24
  },
  "apeld-centrum": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 8,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 11
  },
  "apeld-zuidoost": {
    "1-bedroom-apartment": 8,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 5,
    "unfurnished-apartment": 10
  },
  "apeldoorn": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 16,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 23,
    "apartment-with-elevator": 19,
    "apartment-with-private-parking": 6,
    "family-house": 11,
    "green-energy-apartment": 28,
    "green-energy-house": 10,
    "house-for-rent": 11,
    "house-with-garden": 11,
    "unfurnished-apartment": 35,
    "unfurnished-house": 11,
    "unfurnished-room": 5
  },
  "arnhe-centrum": {
    "student-housing": 6
  },
  "arnhem": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 12,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 6,
    "flat-for-students": 6,
    "furnished-apartment": 9,
    "furnished-room": 16,
    "green-energy-apartment": 14,
    "green-energy-room": 8,
    "renovated-apartment": 7,
    "room-for-students": 32,
    "student-housing": 38,
    "studio-for-rent": 6,
    "unfurnished-apartment": 16,
    "unfurnished-room": 22
  },
  "assen": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 6,
    "green-energy-apartment": 6,
    "unfurnished-apartment": 10
  },
  "bergen-op-zoom": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 14,
    "apartment-with-elevator": 5,
    "family-house": 5,
    "green-energy-apartment": 7,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 12
  },
  "bergpolder": {
    "1-bedroom-apartment": 6,
    "apartment-with-balcony": 10,
    "flat-for-students": 5,
    "student-housing": 9,
    "unfurnished-apartment": 10
  },
  "blijdorp": {
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 9,
    "unfurnished-apartment": 8
  },
  "bloemhof": {
    "apartment-with-balcony": 6,
    "furnished-apartment": 5,
    "student-housing": 8
  },
  "bospolder": {
    "student-housing": 6
  },
  "breda": {
    "1-bedroom-apartment": 22,
    "2-bedroom-apartment": 26,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 34,
    "apartment-with-elevator": 26,
    "apartment-with-private-parking": 10,
    "family-house": 15,
    "flat-for-students": 14,
    "furnished-apartment": 7,
    "furnished-room": 5,
    "green-energy-apartment": 25,
    "green-energy-house": 9,
    "green-energy-room": 6,
    "house-for-rent": 16,
    "house-with-garden": 14,
    "room-for-students": 29,
    "student-housing": 43,
    "studio-for-rent": 14,
    "unfurnished-apartment": 50,
    "unfurnished-house": 13,
    "unfurnished-room": 27,
    "unfurnished-studio": 10
  },
  "brunssum": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "unfurnished-apartment": 8
  },
  "capelle-aan-den-ijssel": {
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 6,
    "flat-for-students": 5,
    "furnished-apartment": 5,
    "furnished-room": 12,
    "green-energy-apartment": 7,
    "room-for-students": 8,
    "student-housing": 13,
    "unfurnished-apartment": 5
  },
  "carnisse": {
    "furnished-room": 11,
    "room-for-students": 11,
    "student-housing": 11
  },
  "centr-bergen": {
    "flat-for-students": 5,
    "furnished-room": 5,
    "room-for-students": 16,
    "student-housing": 21,
    "studio-for-rent": 6,
    "unfurnished-room": 11
  },
  "centr-binnenstad-noord": {
    "room-for-students": 7,
    "student-housing": 7,
    "unfurnished-room": 10
  },
  "centr-binnenstad-zuid": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "renovated-apartment": 6,
    "room-for-students": 5,
    "student-housing": 9,
    "unfurnished-apartment": 11
  },
  "centr-fellenoord": {
    "green-energy-room": 6,
    "room-with-laundry": 5,
    "student-housing": 5
  },
  "centrum-rcigi": {
    "unfurnished-apartment": 5
  },
  "charlois": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 13,
    "apartment-with-balcony": 12,
    "apartment-with-elevator": 5,
    "flat-for-students": 6,
    "furnished-apartment": 6,
    "furnished-room": 16,
    "room-for-students": 19,
    "student-housing": 25,
    "unfurnished-apartment": 16,
    "unfurnished-room": 5
  },
  "delfs-middelland": {
    "2-bedroom-apartment": 5,
    "furnished-apartment": 6,
    "student-housing": 6
  },
  "delft": {
    "1-bedroom-apartment": 17,
    "2-bedroom-apartment": 15,
    "3-bedroom-apartment": 7,
    "apartment-with-balcony": 23,
    "apartment-with-elevator": 16,
    "apartment-with-laundry": 5,
    "flat-for-students": 31,
    "furnished-apartment": 12,
    "furnished-room": 26,
    "furnished-studio": 7,
    "green-energy-apartment": 18,
    "green-energy-room": 5,
    "green-energy-studio": 11,
    "room-for-students": 39,
    "room-with-laundry": 11,
    "student-housing": 71,
    "studio-for-rent": 19,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 35,
    "unfurnished-room": 15,
    "unfurnished-studio": 12
  },
  "den-haag": {
    "1-bedroom-apartment": 99,
    "2-bedroom-apartment": 141,
    "3-bedroom-apartment": 41,
    "4-bedroom-apartment": 6,
    "apartment-with-balcony": 177,
    "apartment-with-elevator": 88,
    "apartment-with-garden": 25,
    "apartment-with-laundry": 32,
    "apartment-with-private-parking": 38,
    "apartment-with-security": 13,
    "family-house": 20,
    "flat-for-students": 50,
    "furnished-1-bedroom-apartment": 22,
    "furnished-apartment": 81,
    "furnished-house": 6,
    "furnished-house-with-garden": 6,
    "furnished-room": 30,
    "furnished-studio": 11,
    "green-energy-apartment": 178,
    "green-energy-house": 7,
    "green-energy-room": 7,
    "green-energy-studio": 17,
    "house-for-rent": 23,
    "house-with-garden": 19,
    "pet-friendly-apartment": 12,
    "renovated-apartment": 39,
    "room-for-students": 42,
    "student-housing": 92,
    "studio-for-rent": 34,
    "studio-with-laundry": 10,
    "unfurnished-apartment": 221,
    "unfurnished-house": 17,
    "unfurnished-room": 16,
    "unfurnished-studio": 23
  },
  "den-helder": {
    "3-bedroom-house": 5,
    "apartment-with-balcony": 7,
    "family-house": 6,
    "green-energy-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 8,
    "unfurnished-house": 6
  },
  "deven-binnenstad": {
    "student-housing": 6,
    "unfurnished-apartment": 6
  },
  "deventer": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 6,
    "apartment-with-balcony": 9,
    "family-house": 8,
    "green-energy-apartment": 5,
    "green-energy-room": 5,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "room-for-students": 8,
    "student-housing": 13,
    "unfurnished-apartment": 15,
    "unfurnished-house": 8
  },
  "diemen": {
    "2-bedroom-apartment": 10,
    "3-bedroom-apartment": 9,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 6,
    "green-energy-apartment": 20,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-apartment": 19
  },
  "dordrecht": {
    "2-bedroom-apartment": 8,
    "furnished-apartment": 7,
    "green-energy-apartment": 9,
    "unfurnished-apartment": 7
  },
  "drechterland": {
    "2-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "family-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-house": 5
  },
  "drenthe": {
    "1-bedroom-apartment": 18,
    "2-bedroom-apartment": 21,
    "2-bedroom-house": 14,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 21,
    "apartment-with-balcony": 29,
    "apartment-with-elevator": 16,
    "apartment-with-garden": 5,
    "family-house": 37,
    "furnished-apartment": 9,
    "green-energy-apartment": 28,
    "green-energy-house": 21,
    "house-for-rent": 43,
    "house-with-garden": 41,
    "room-for-students": 18,
    "student-housing": 22,
    "unfurnished-apartment": 42,
    "unfurnished-house": 42,
    "unfurnished-room": 21
  },
  "edam-volendam": {
    "1-bedroom-apartment": 7,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 8
  },
  "ede": {
    "room-for-students": 6,
    "student-housing": 8
  },
  "eindh-centrum": {
    "1-bedroom-apartment": 13,
    "2-bedroom-apartment": 6,
    "apartment-with-elevator": 8,
    "apartment-with-laundry": 8,
    "flat-for-students": 48,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 12,
    "furnished-room": 42,
    "furnished-studio": 29,
    "green-energy-apartment": 11,
    "green-energy-room": 59,
    "green-energy-studio": 32,
    "room-for-students": 71,
    "room-with-laundry": 47,
    "student-housing": 119,
    "studio-for-rent": 40,
    "studio-with-laundry": 26,
    "studio-with-study-space": 10,
    "unfurnished-apartment": 9,
    "unfurnished-room": 31,
    "unfurnished-studio": 11
  },
  "eindhoven": {
    "1-bedroom-apartment": 109,
    "2-bedroom-apartment": 54,
    "2-bedroom-house": 7,
    "3-bedroom-apartment": 6,
    "3-bedroom-house": 11,
    "apartment-with-balcony": 60,
    "apartment-with-elevator": 30,
    "apartment-with-garden": 21,
    "apartment-with-laundry": 20,
    "apartment-with-private-parking": 31,
    "apartment-with-security": 5,
    "family-house": 23,
    "flat-for-students": 232,
    "furnished-1-bedroom-apartment": 55,
    "furnished-apartment": 84,
    "furnished-house": 8,
    "furnished-house-with-garden": 5,
    "furnished-room": 121,
    "furnished-studio": 67,
    "green-energy-apartment": 72,
    "green-energy-house": 12,
    "green-energy-room": 167,
    "green-energy-studio": 81,
    "house-for-rent": 28,
    "house-with-garden": 18,
    "renovated-apartment": 13,
    "room-for-students": 266,
    "room-with-laundry": 67,
    "student-housing": 502,
    "studio-for-rent": 148,
    "studio-with-balcony": 13,
    "studio-with-laundry": 62,
    "studio-with-study-space": 10,
    "unfurnished-apartment": 95,
    "unfurnished-house": 20,
    "unfurnished-room": 155,
    "unfurnished-studio": 81
  },
  "emmen": {
    "apartment-with-balcony": 7,
    "green-energy-apartment": 8,
    "room-for-students": 12,
    "student-housing": 13,
    "unfurnished-apartment": 10,
    "unfurnished-room": 12
  },
  "enkhuizen": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 17,
    "3-bedroom-house": 12,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 5,
    "apartment-with-garden": 7,
    "family-house": 15,
    "furnished-1-bedroom-apartment": 10,
    "furnished-apartment": 26,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "house-for-rent": 15,
    "house-with-garden": 13,
    "unfurnished-apartment": 7,
    "unfurnished-house": 6
  },
  "enschede": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 9,
    "3-bedroom-apartment": 8,
    "apartment-with-balcony": 10,
    "apartment-with-private-parking": 5,
    "family-house": 6,
    "flat-for-students": 22,
    "furnished-apartment": 5,
    "furnished-room": 32,
    "furnished-studio": 9,
    "green-energy-room": 27,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "room-for-students": 80,
    "room-with-laundry": 6,
    "student-housing": 104,
    "studio-for-rent": 18,
    "unfurnished-apartment": 23,
    "unfurnished-house": 7,
    "unfurnished-room": 57,
    "unfurnished-studio": 9
  },
  "flevoland": {
    "1-bedroom-apartment": 27,
    "2-bedroom-apartment": 22,
    "2-bedroom-house": 8,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 27,
    "apartment-with-elevator": 18,
    "apartment-with-garden": 13,
    "apartment-with-laundry": 5,
    "apartment-with-private-parking": 21,
    "apartment-with-security": 6,
    "family-house": 26,
    "flat-for-students": 10,
    "furnished-1-bedroom-apartment": 13,
    "furnished-apartment": 25,
    "furnished-house": 7,
    "furnished-house-with-garden": 7,
    "furnished-room": 14,
    "green-energy-apartment": 48,
    "green-energy-house": 15,
    "green-energy-room": 8,
    "green-energy-studio": 5,
    "house-for-rent": 26,
    "house-with-garden": 24,
    "house-with-private-parking": 10,
    "renovated-apartment": 6,
    "room-for-students": 18,
    "student-housing": 31,
    "studio-for-rent": 7,
    "unfurnished-apartment": 40,
    "unfurnished-house": 19,
    "unfurnished-room": 9
  },
  "frysln": {
    "1-bedroom-apartment": 31,
    "1-bedroom-house": 7,
    "2-bedroom-apartment": 39,
    "2-bedroom-house": 11,
    "3-bedroom-apartment": 11,
    "3-bedroom-house": 22,
    "apartment-with-balcony": 52,
    "apartment-with-elevator": 29,
    "apartment-with-garden": 13,
    "apartment-with-private-parking": 6,
    "family-house": 44,
    "flat-for-students": 8,
    "furnished-apartment": 8,
    "furnished-room": 7,
    "green-energy-apartment": 44,
    "green-energy-house": 28,
    "house-for-rent": 51,
    "house-with-garden": 50,
    "room-for-students": 19,
    "student-housing": 27,
    "studio-for-rent": 5,
    "unfurnished-apartment": 76,
    "unfurnished-house": 49,
    "unfurnished-room": 14
  },
  "gelderland": {
    "1-bedroom-apartment": 59,
    "2-bedroom-apartment": 58,
    "2-bedroom-house": 19,
    "3-bedroom-apartment": 11,
    "3-bedroom-house": 25,
    "apartment-with-balcony": 65,
    "apartment-with-elevator": 40,
    "apartment-with-garden": 17,
    "apartment-with-laundry": 7,
    "apartment-with-private-parking": 25,
    "apartment-with-security": 6,
    "family-house": 49,
    "flat-for-students": 25,
    "furnished-1-bedroom-apartment": 19,
    "furnished-apartment": 38,
    "furnished-house": 10,
    "furnished-house-with-garden": 7,
    "furnished-room": 54,
    "furnished-studio": 5,
    "green-energy-apartment": 78,
    "green-energy-house": 33,
    "green-energy-room": 26,
    "green-energy-studio": 6,
    "house-for-rent": 54,
    "house-with-garden": 50,
    "house-with-private-parking": 9,
    "pet-friendly-apartment": 5,
    "renovated-apartment": 17,
    "room-for-students": 127,
    "room-with-laundry": 6,
    "student-housing": 152,
    "studio-for-rent": 20,
    "unfurnished-apartment": 101,
    "unfurnished-house": 44,
    "unfurnished-room": 93,
    "unfurnished-studio": 15
  },
  "geldrop-mierlo": {
    "furnished-studio": 5,
    "studio-for-rent": 5
  },
  "goes": {
    "family-house": 6,
    "green-energy-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-house": 6
  },
  "groni-centrum": {
    "1-bedroom-apartment": 14,
    "2-bedroom-apartment": 10,
    "apartment-with-garden": 5,
    "flat-for-students": 10,
    "furnished-apartment": 6,
    "green-energy-apartment": 6,
    "green-energy-room": 6,
    "renovated-apartment": 9,
    "room-for-students": 25,
    "student-housing": 35,
    "studio-for-rent": 7,
    "unfurnished-apartment": 22,
    "unfurnished-room": 29,
    "unfurnished-studio": 5
  },
  "groningen": {
    "1-bedroom-apartment": 29,
    "2-bedroom-apartment": 28,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 19,
    "apartment-with-elevator": 6,
    "apartment-with-garden": 12,
    "apartment-with-private-parking": 7,
    "family-house": 6,
    "flat-for-students": 28,
    "furnished-apartment": 14,
    "furnished-room": 24,
    "green-energy-apartment": 22,
    "green-energy-house": 5,
    "green-energy-room": 37,
    "house-for-rent": 6,
    "renovated-apartment": 10,
    "room-for-students": 119,
    "room-with-laundry": 14,
    "student-housing": 150,
    "studio-for-rent": 22,
    "unfurnished-apartment": 51,
    "unfurnished-room": 118,
    "unfurnished-studio": 19
  },
  "groningen-province": {
    "1-bedroom-apartment": 38,
    "2-bedroom-apartment": 36,
    "2-bedroom-house": 19,
    "3-bedroom-apartment": 6,
    "3-bedroom-house": 18,
    "apartment-with-balcony": 24,
    "apartment-with-elevator": 10,
    "apartment-with-garden": 16,
    "apartment-with-private-parking": 11,
    "family-house": 44,
    "flat-for-students": 31,
    "furnished-1-bedroom-apartment": 6,
    "furnished-apartment": 17,
    "furnished-room": 25,
    "green-energy-apartment": 29,
    "green-energy-house": 29,
    "green-energy-room": 37,
    "house-for-rent": 46,
    "house-with-garden": 17,
    "house-with-private-parking": 6,
    "renovated-apartment": 13,
    "room-for-students": 121,
    "room-with-laundry": 14,
    "student-housing": 156,
    "studio-for-rent": 23,
    "unfurnished-apartment": 66,
    "unfurnished-house": 42,
    "unfurnished-room": 120,
    "unfurnished-studio": 20
  },
  "haarlem": {
    "1-bedroom-apartment": 21,
    "2-bedroom-apartment": 24,
    "apartment-with-balcony": 23,
    "apartment-with-elevator": 5,
    "apartment-with-private-parking": 22,
    "family-house": 7,
    "flat-for-students": 7,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 14,
    "green-energy-apartment": 34,
    "house-for-rent": 7,
    "house-with-garden": 6,
    "renovated-apartment": 14,
    "room-for-students": 10,
    "student-housing": 17,
    "studio-for-rent": 5,
    "unfurnished-apartment": 35,
    "unfurnished-house": 6,
    "unfurnished-room": 7
  },
  "haarlemmermeer": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 8,
    "furnished-apartment": 5,
    "furnished-room": 9,
    "green-energy-apartment": 5,
    "green-energy-room": 7,
    "room-for-students": 10,
    "student-housing": 11,
    "unfurnished-apartment": 5,
    "unfurnished-room": 5
  },
  "heerenveen": {
    "apartment-with-balcony": 5,
    "green-energy-apartment": 7,
    "unfurnished-apartment": 7
  },
  "heerhugowaard": {
    "unfurnished-apartment": 5
  },
  "heerlen": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 16,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 29,
    "apartment-with-elevator": 17,
    "apartment-with-private-parking": 6,
    "family-house": 7,
    "green-energy-apartment": 11,
    "house-for-rent": 7,
    "house-with-garden": 6,
    "room-for-students": 6,
    "student-housing": 7,
    "unfurnished-apartment": 36,
    "unfurnished-house": 7
  },
  "helmond": {
    "apartment-with-elevator": 5
  },
  "hengelo-o": {
    "furnished-room": 5,
    "room-for-students": 7,
    "student-housing": 11
  },
  "hillegersberg-schiebroek": {
    "unfurnished-apartment": 6
  },
  "hilversum": {
    "1-bedroom-apartment": 6,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 5,
    "family-house": 5,
    "furnished-room": 6,
    "green-energy-apartment": 8,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-apartment": 11
  },
  "hoogeveen": {
    "unfurnished-apartment": 7
  },
  "huizen": {
    "family-house": 5,
    "house-for-rent": 5,
    "unfurnished-house": 5
  },
  "ijsselmonde": {
    "2-bedroom-apartment": 8,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "furnished-room": 5,
    "unfurnished-apartment": 6
  },
  "katendrecht": {
    "2-bedroom-apartment": 9,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 8,
    "green-energy-apartment": 14,
    "unfurnished-apartment": 15
  },
  "kerkrade": {
    "1-bedroom-apartment": 6,
    "2-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 9,
    "apartment-with-elevator": 5,
    "family-house": 6,
    "green-energy-apartment": 6,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 15,
    "unfurnished-house": 5
  },
  "leeuwarden": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 14,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 21,
    "apartment-with-elevator": 15,
    "family-house": 9,
    "furnished-room": 7,
    "green-energy-apartment": 13,
    "green-energy-house": 7,
    "house-for-rent": 11,
    "house-with-garden": 10,
    "room-for-students": 19,
    "student-housing": 21,
    "unfurnished-apartment": 32,
    "unfurnished-house": 11,
    "unfurnished-room": 13
  },
  "leiden": {
    "1-bedroom-apartment": 23,
    "2-bedroom-apartment": 13,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 18,
    "apartment-with-elevator": 17,
    "apartment-with-private-parking": 9,
    "apartment-with-security": 5,
    "family-house": 11,
    "flat-for-students": 11,
    "furnished-apartment": 6,
    "green-energy-apartment": 24,
    "green-energy-house": 6,
    "green-energy-room": 6,
    "green-energy-studio": 9,
    "house-for-rent": 11,
    "house-with-garden": 9,
    "room-for-students": 14,
    "student-housing": 27,
    "studio-for-rent": 14,
    "unfurnished-apartment": 38,
    "unfurnished-house": 9,
    "unfurnished-room": 12,
    "unfurnished-studio": 11
  },
  "leidschendam-voorburg": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 9,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 10,
    "apartment-with-private-parking": 5,
    "family-house": 7,
    "green-energy-apartment": 10,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "unfurnished-apartment": 14
  },
  "lelystad": {
    "1-bedroom-apartment": 19,
    "2-bedroom-apartment": 12,
    "2-bedroom-house": 8,
    "apartment-with-balcony": 11,
    "apartment-with-elevator": 8,
    "apartment-with-garden": 8,
    "apartment-with-private-parking": 16,
    "family-house": 14,
    "flat-for-students": 5,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 14,
    "green-energy-apartment": 26,
    "green-energy-house": 6,
    "house-for-rent": 14,
    "house-with-garden": 12,
    "house-with-private-parking": 7,
    "student-housing": 9,
    "unfurnished-apartment": 20,
    "unfurnished-house": 14
  },
  "limbu-weert": {
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 10,
    "green-energy-apartment": 9,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 11,
    "unfurnished-house": 5
  },
  "limburg": {
    "1-bedroom-apartment": 100,
    "1-bedroom-house": 5,
    "2-bedroom-apartment": 123,
    "2-bedroom-house": 14,
    "3-bedroom-apartment": 24,
    "3-bedroom-house": 58,
    "apartment-with-balcony": 153,
    "apartment-with-elevator": 112,
    "apartment-with-garden": 23,
    "apartment-with-laundry": 8,
    "apartment-with-private-parking": 29,
    "apartment-with-security": 6,
    "family-house": 90,
    "flat-for-students": 26,
    "furnished-1-bedroom-apartment": 17,
    "furnished-apartment": 33,
    "furnished-house": 10,
    "furnished-house-with-garden": 6,
    "furnished-room": 28,
    "furnished-studio": 15,
    "green-energy-apartment": 113,
    "green-energy-house": 50,
    "green-energy-room": 9,
    "house-for-rent": 100,
    "house-with-garden": 88,
    "house-with-private-parking": 17,
    "newly-built-apartment": 5,
    "pet-friendly-apartment": 14,
    "pet-friendly-house": 6,
    "renovated-apartment": 18,
    "room-for-students": 53,
    "room-with-laundry": 7,
    "student-housing": 80,
    "studio-for-rent": 32,
    "studio-with-laundry": 10,
    "studio-with-study-space": 7,
    "unfurnished-apartment": 233,
    "unfurnished-house": 90,
    "unfurnished-room": 32,
    "unfurnished-studio": 17
  },
  "lisse": {
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 5,
    "unfurnished-apartment": 6
  },
  "maastricht": {
    "1-bedroom-apartment": 27,
    "2-bedroom-apartment": 44,
    "3-bedroom-house": 7,
    "apartment-with-balcony": 47,
    "apartment-with-elevator": 29,
    "apartment-with-garden": 5,
    "apartment-with-private-parking": 5,
    "family-house": 14,
    "flat-for-students": 13,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 14,
    "furnished-room": 10,
    "furnished-studio": 12,
    "green-energy-apartment": 33,
    "green-energy-house": 5,
    "house-for-rent": 14,
    "house-with-garden": 12,
    "pet-friendly-apartment": 6,
    "renovated-apartment": 6,
    "room-for-students": 24,
    "room-with-laundry": 5,
    "student-housing": 37,
    "studio-for-rent": 16,
    "studio-with-laundry": 10,
    "studio-with-study-space": 7,
    "unfurnished-apartment": 68,
    "unfurnished-house": 11,
    "unfurnished-room": 19
  },
  "meerzicht": {
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 8,
    "apartment-with-security": 5,
    "unfurnished-apartment": 8
  },
  "meppel": {
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 5,
    "furnished-apartment": 5
  },
  "netherlands": {
    "1-bedroom-apartment": 1324,
    "1-bedroom-house": 63,
    "2-bedroom-apartment": 1648,
    "2-bedroom-house": 229,
    "3-bedroom-apartment": 439,
    "3-bedroom-house": 536,
    "4-bedroom-apartment": 52,
    "apartment-with-balcony": 1979,
    "apartment-with-elevator": 1156,
    "apartment-with-garden": 379,
    "apartment-with-laundry": 164,
    "apartment-with-private-parking": 492,
    "apartment-with-security": 166,
    "family-house": 1001,
    "flat-for-students": 925,
    "furnished-1-bedroom-apartment": 431,
    "furnished-apartment": 1038,
    "furnished-house": 200,
    "furnished-house-with-garden": 157,
    "furnished-room": 788,
    "furnished-studio": 259,
    "green-energy-apartment": 1964,
    "green-energy-house": 567,
    "green-energy-room": 535,
    "green-energy-studio": 251,
    "house-for-rent": 1099,
    "house-with-garden": 926,
    "house-with-private-parking": 141,
    "newly-built-apartment": 96,
    "newly-built-house": 13,
    "pet-friendly-apartment": 127,
    "pet-friendly-house": 51,
    "renovated-apartment": 371,
    "renovated-house": 73,
    "room-for-students": 1479,
    "room-with-laundry": 174,
    "student-housing": 2460,
    "studio-for-rent": 628,
    "studio-with-balcony": 59,
    "studio-with-garden": 30,
    "studio-with-laundry": 173,
    "studio-with-study-space": 48,
    "unfurnished-apartment": 2595,
    "unfurnished-house": 899,
    "unfurnished-room": 947,
    "unfurnished-studio": 369
  },
  "nieuwe-westen": {
    "1-bedroom-apartment": 8,
    "2-bedroom-apartment": 7,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "apartment-with-private-parking": 5,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 13,
    "green-energy-apartment": 7,
    "renovated-apartment": 6,
    "room-for-students": 7,
    "student-housing": 11,
    "unfurnished-apartment": 11
  },
  "nieuwegein": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "green-energy-apartment": 9,
    "room-for-students": 5,
    "student-housing": 5,
    "unfurnished-apartment": 7
  },
  "nijmegen": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "apartment-with-private-parking": 9,
    "furnished-1-bedroom-apartment": 11,
    "furnished-apartment": 17,
    "furnished-room": 7,
    "green-energy-apartment": 16,
    "renovated-apartment": 5,
    "room-for-students": 20,
    "student-housing": 24,
    "unfurnished-apartment": 10,
    "unfurnished-room": 14
  },
  "nijmegen-centrum": {
    "furnished-apartment": 7,
    "green-energy-apartment": 5,
    "student-housing": 5
  },
  "nijmegen-oost": {
    "room-for-students": 7,
    "student-housing": 8,
    "unfurnished-room": 6
  },
  "noord-brabant": {
    "1-bedroom-apartment": 227,
    "1-bedroom-house": 10,
    "2-bedroom-apartment": 187,
    "2-bedroom-house": 23,
    "3-bedroom-apartment": 36,
    "3-bedroom-house": 91,
    "apartment-with-balcony": 225,
    "apartment-with-elevator": 151,
    "apartment-with-garden": 49,
    "apartment-with-laundry": 26,
    "apartment-with-private-parking": 83,
    "apartment-with-security": 13,
    "family-house": 155,
    "flat-for-students": 285,
    "furnished-1-bedroom-apartment": 87,
    "furnished-apartment": 149,
    "furnished-house": 29,
    "furnished-house-with-garden": 22,
    "furnished-room": 147,
    "furnished-studio": 86,
    "green-energy-apartment": 231,
    "green-energy-house": 89,
    "green-energy-room": 192,
    "green-energy-studio": 92,
    "house-for-rent": 173,
    "house-with-garden": 146,
    "house-with-private-parking": 25,
    "newly-built-apartment": 15,
    "newly-built-house": 7,
    "pet-friendly-apartment": 11,
    "pet-friendly-house": 5,
    "renovated-apartment": 44,
    "renovated-house": 12,
    "room-for-students": 354,
    "room-with-laundry": 77,
    "student-housing": 649,
    "studio-for-rent": 212,
    "studio-with-balcony": 23,
    "studio-with-laundry": 71,
    "studio-with-study-space": 11,
    "unfurnished-apartment": 325,
    "unfurnished-house": 144,
    "unfurnished-room": 235,
    "unfurnished-studio": 126
  },
  "noord-holland": {
    "1-bedroom-apartment": 323,
    "1-bedroom-house": 7,
    "2-bedroom-apartment": 446,
    "2-bedroom-house": 53,
    "3-bedroom-apartment": 107,
    "3-bedroom-house": 105,
    "4-bedroom-apartment": 12,
    "apartment-with-balcony": 518,
    "apartment-with-elevator": 243,
    "apartment-with-garden": 102,
    "apartment-with-laundry": 35,
    "apartment-with-private-parking": 116,
    "apartment-with-security": 24,
    "family-house": 211,
    "flat-for-students": 162,
    "furnished-1-bedroom-apartment": 153,
    "furnished-apartment": 373,
    "furnished-house": 57,
    "furnished-house-with-garden": 46,
    "furnished-room": 200,
    "furnished-studio": 41,
    "green-energy-apartment": 540,
    "green-energy-house": 91,
    "green-energy-room": 94,
    "green-energy-studio": 44,
    "house-for-rent": 223,
    "house-with-garden": 187,
    "house-with-private-parking": 25,
    "newly-built-apartment": 28,
    "newly-built-house": 5,
    "pet-friendly-apartment": 40,
    "pet-friendly-house": 16,
    "renovated-apartment": 83,
    "renovated-house": 19,
    "room-for-students": 180,
    "room-with-laundry": 14,
    "student-housing": 350,
    "studio-for-rent": 71,
    "studio-with-balcony": 8,
    "studio-with-garden": 5,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 549,
    "unfurnished-house": 166,
    "unfurnished-room": 46,
    "unfurnished-studio": 30
  },
  "noord-hoorn": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 27,
    "3-bedroom-house": 10,
    "apartment-with-balcony": 24,
    "apartment-with-elevator": 9,
    "apartment-with-garden": 9,
    "family-house": 17,
    "flat-for-students": 6,
    "furnished-1-bedroom-apartment": 9,
    "furnished-apartment": 19,
    "green-energy-apartment": 12,
    "house-for-rent": 17,
    "house-with-garden": 15,
    "student-housing": 6,
    "unfurnished-apartment": 28,
    "unfurnished-house": 13
  },
  "noord-medemblik": {
    "1-bedroom-apartment": 13,
    "2-bedroom-apartment": 11,
    "2-bedroom-house": 5,
    "3-bedroom-house": 7,
    "apartment-with-balcony": 13,
    "apartment-with-elevator": 6,
    "family-house": 14,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 13,
    "house-for-rent": 14,
    "house-with-garden": 13,
    "unfurnished-apartment": 12,
    "unfurnished-house": 12
  },
  "noord-veldhoven": {
    "3-bedroom-house": 5,
    "family-house": 8,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "unfurnished-apartment": 6,
    "unfurnished-house": 7
  },
  "noord-waterland": {
    "furnished-apartment": 6,
    "house-for-rent": 5,
    "house-with-garden": 5
  },
  "noord-zandvoort": {
    "green-energy-apartment": 5,
    "student-housing": 5
  },
  "nude": {
    "room-for-students": 9,
    "student-housing": 11,
    "unfurnished-room": 5
  },
  "oldambt": {
    "house-for-rent": 5,
    "unfurnished-apartment": 5,
    "unfurnished-house": 5
  },
  "oss": {
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 8
  },
  "oude-noorden": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 10,
    "flat-for-students": 5,
    "furnished-apartment": 7,
    "renovated-apartment": 5,
    "room-for-students": 5,
    "student-housing": 11,
    "unfurnished-apartment": 7
  },
  "overi-zwolle": {
    "1-bedroom-apartment": 14,
    "2-bedroom-apartment": 13,
    "3-bedroom-house": 8,
    "apartment-with-balcony": 17,
    "apartment-with-elevator": 12,
    "apartment-with-private-parking": 7,
    "family-house": 10,
    "flat-for-students": 11,
    "furnished-apartment": 6,
    "green-energy-apartment": 22,
    "green-energy-house": 10,
    "house-for-rent": 10,
    "house-with-garden": 10,
    "room-for-students": 18,
    "student-housing": 29,
    "studio-for-rent": 5,
    "unfurnished-apartment": 31,
    "unfurnished-house": 9,
    "unfurnished-room": 27
  },
  "overijssel": {
    "1-bedroom-apartment": 48,
    "2-bedroom-apartment": 40,
    "2-bedroom-house": 12,
    "3-bedroom-apartment": 19,
    "3-bedroom-house": 34,
    "4-bedroom-apartment": 5,
    "apartment-with-balcony": 55,
    "apartment-with-elevator": 30,
    "apartment-with-garden": 12,
    "apartment-with-private-parking": 17,
    "family-house": 52,
    "flat-for-students": 51,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 19,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "furnished-room": 50,
    "furnished-studio": 16,
    "green-energy-apartment": 49,
    "green-energy-house": 28,
    "green-energy-room": 36,
    "green-energy-studio": 7,
    "house-for-rent": 59,
    "house-with-garden": 50,
    "house-with-private-parking": 5,
    "renovated-apartment": 12,
    "room-for-students": 122,
    "room-with-laundry": 7,
    "student-housing": 184,
    "studio-for-rent": 36,
    "studio-with-laundry": 8,
    "unfurnished-apartment": 99,
    "unfurnished-house": 50,
    "unfurnished-room": 95,
    "unfurnished-studio": 20
  },
  "paleiskwartier": {
    "2-bedroom-apartment": 11,
    "apartment-with-balcony": 12,
    "apartment-with-private-parking": 5,
    "furnished-apartment": 7,
    "green-energy-apartment": 12,
    "unfurnished-apartment": 6
  },
  "prins-alexander": {
    "apartment-with-balcony": 6,
    "flat-for-students": 5,
    "furnished-room": 5,
    "green-energy-apartment": 5,
    "room-for-students": 6,
    "student-housing": 11,
    "studio-for-rent": 5,
    "unfurnished-apartment": 5
  },
  "purmerend": {
    "1-bedroom-apartment": 47,
    "2-bedroom-apartment": 48,
    "2-bedroom-house": 16,
    "3-bedroom-apartment": 10,
    "3-bedroom-house": 11,
    "apartment-with-balcony": 77,
    "apartment-with-elevator": 48,
    "apartment-with-garden": 8,
    "apartment-with-laundry": 6,
    "apartment-with-security": 7,
    "family-house": 29,
    "flat-for-students": 12,
    "furnished-1-bedroom-apartment": 16,
    "furnished-apartment": 29,
    "green-energy-apartment": 88,
    "green-energy-house": 23,
    "house-for-rent": 29,
    "house-with-garden": 28,
    "newly-built-apartment": 5,
    "student-housing": 14,
    "unfurnished-apartment": 79,
    "unfurnished-house": 28
  },
  "roermond": {
    "1-bedroom-apartment": 12,
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 14,
    "apartment-with-elevator": 13,
    "flat-for-students": 5,
    "green-energy-apartment": 9,
    "student-housing": 5,
    "unfurnished-apartment": 20
  },
  "roosendaal": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 6,
    "apartment-with-elevator": 5,
    "family-house": 5,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 11
  },
  "rotte-delfshaven": {
    "1-bedroom-apartment": 19,
    "2-bedroom-apartment": 20,
    "3-bedroom-apartment": 8,
    "apartment-with-balcony": 22,
    "apartment-with-elevator": 13,
    "apartment-with-garden": 9,
    "apartment-with-private-parking": 7,
    "flat-for-students": 14,
    "furnished-1-bedroom-apartment": 12,
    "furnished-apartment": 26,
    "furnished-room": 15,
    "green-energy-apartment": 19,
    "green-energy-room": 7,
    "renovated-apartment": 9,
    "room-for-students": 25,
    "student-housing": 39,
    "unfurnished-apartment": 30,
    "unfurnished-room": 12
  },
  "rotte-feijenoord": {
    "1-bedroom-apartment": 25,
    "2-bedroom-apartment": 34,
    "3-bedroom-apartment": 13,
    "4-bedroom-apartment": 6,
    "apartment-with-balcony": 46,
    "apartment-with-elevator": 25,
    "apartment-with-laundry": 6,
    "apartment-with-private-parking": 12,
    "apartment-with-security": 8,
    "flat-for-students": 16,
    "furnished-1-bedroom-apartment": 10,
    "furnished-apartment": 25,
    "furnished-room": 9,
    "green-energy-apartment": 51,
    "green-energy-room": 5,
    "newly-built-apartment": 5,
    "renovated-apartment": 8,
    "room-for-students": 14,
    "student-housing": 32,
    "studio-for-rent": 7,
    "unfurnished-apartment": 55,
    "unfurnished-room": 5
  },
  "rotte-noord": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 18,
    "3-bedroom-apartment": 12,
    "apartment-with-balcony": 35,
    "apartment-with-garden": 11,
    "flat-for-students": 12,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 21,
    "green-energy-apartment": 12,
    "green-energy-room": 5,
    "renovated-apartment": 13,
    "room-for-students": 14,
    "student-housing": 27,
    "unfurnished-apartment": 33,
    "unfurnished-room": 11
  },
  "rotterdam": {
    "1-bedroom-apartment": 114,
    "2-bedroom-apartment": 189,
    "3-bedroom-apartment": 65,
    "3-bedroom-house": 7,
    "4-bedroom-apartment": 17,
    "apartment-with-balcony": 242,
    "apartment-with-elevator": 127,
    "apartment-with-garden": 36,
    "apartment-with-laundry": 17,
    "apartment-with-private-parking": 43,
    "apartment-with-security": 37,
    "family-house": 13,
    "flat-for-students": 107,
    "furnished-1-bedroom-apartment": 53,
    "furnished-apartment": 152,
    "furnished-house": 12,
    "furnished-house-with-garden": 8,
    "furnished-room": 68,
    "furnished-studio": 29,
    "green-energy-apartment": 194,
    "green-energy-room": 35,
    "green-energy-studio": 21,
    "house-for-rent": 15,
    "house-with-garden": 11,
    "newly-built-apartment": 14,
    "pet-friendly-apartment": 22,
    "renovated-apartment": 56,
    "room-for-students": 114,
    "room-with-laundry": 17,
    "student-housing": 226,
    "studio-for-rent": 48,
    "studio-with-laundry": 12,
    "studio-with-study-space": 5,
    "unfurnished-apartment": 253,
    "unfurnished-room": 59,
    "unfurnished-studio": 19
  },
  "s-her-west": {
    "1-bedroom-apartment": 6,
    "2-bedroom-apartment": 14,
    "apartment-with-balcony": 18,
    "apartment-with-elevator": 7,
    "apartment-with-private-parking": 6,
    "furnished-apartment": 7,
    "green-energy-apartment": 18,
    "unfurnished-apartment": 15
  },
  "s-hertogenbosch": {
    "1-bedroom-apartment": 20,
    "2-bedroom-apartment": 23,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 25,
    "apartment-with-elevator": 15,
    "apartment-with-private-parking": 7,
    "family-house": 5,
    "furnished-apartment": 16,
    "green-energy-apartment": 31,
    "green-energy-house": 5,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "renovated-apartment": 13,
    "room-for-students": 7,
    "student-housing": 9,
    "unfurnished-apartment": 33,
    "unfurnished-room": 5
  },
  "schagen": {
    "green-energy-apartment": 5,
    "unfurnished-apartment": 5
  },
  "schiedam": {
    "2-bedroom-apartment": 9,
    "apartment-with-garden": 6,
    "family-house": 5,
    "furnished-apartment": 6,
    "green-energy-apartment": 12,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "renovated-apartment": 6,
    "student-housing": 5,
    "unfurnished-apartment": 11,
    "unfurnished-house": 5,
    "unfurnished-room": 5
  },
  "sdwest-frysln": {
    "2-bedroom-apartment": 8,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 6,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 10
  },
  "sittard-geleen": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "family-house": 7,
    "green-energy-apartment": 9,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "renovated-apartment": 5,
    "room-for-students": 6,
    "student-housing": 10,
    "unfurnished-apartment": 17,
    "unfurnished-house": 7
  },
  "smallingerland": {
    "apartment-with-balcony": 9,
    "unfurnished-apartment": 10
  },
  "spijkerkwartier": {
    "room-for-students": 6,
    "student-housing": 7,
    "unfurnished-room": 6
  },
  "stede-broec": {
    "3-bedroom-house": 6,
    "family-house": 12,
    "house-for-rent": 13,
    "house-with-garden": 13,
    "unfurnished-house": 12
  },
  "terneuzen": {
    "apartment-with-balcony": 6,
    "unfurnished-apartment": 6
  },
  "tilburg": {
    "1-bedroom-apartment": 26,
    "2-bedroom-apartment": 22,
    "3-bedroom-apartment": 6,
    "3-bedroom-house": 19,
    "apartment-with-balcony": 30,
    "apartment-with-elevator": 24,
    "apartment-with-private-parking": 7,
    "family-house": 22,
    "flat-for-students": 28,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 14,
    "furnished-room": 10,
    "furnished-studio": 6,
    "green-energy-apartment": 24,
    "green-energy-house": 14,
    "green-energy-room": 14,
    "green-energy-studio": 6,
    "house-for-rent": 24,
    "house-with-garden": 22,
    "house-with-private-parking": 5,
    "renovated-apartment": 7,
    "room-for-students": 42,
    "student-housing": 72,
    "studio-for-rent": 30,
    "studio-with-balcony": 8,
    "unfurnished-apartment": 43,
    "unfurnished-house": 23,
    "unfurnished-room": 39,
    "unfurnished-studio": 24
  },
  "utrecht": {
    "1-bedroom-apartment": 34,
    "2-bedroom-apartment": 44,
    "3-bedroom-apartment": 9,
    "3-bedroom-house": 6,
    "apartment-with-balcony": 38,
    "apartment-with-elevator": 16,
    "apartment-with-garden": 6,
    "apartment-with-private-parking": 25,
    "family-house": 11,
    "flat-for-students": 44,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 28,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "furnished-room": 33,
    "furnished-studio": 10,
    "green-energy-apartment": 52,
    "green-energy-house": 5,
    "green-energy-room": 10,
    "green-energy-studio": 7,
    "house-for-rent": 16,
    "house-with-garden": 12,
    "renovated-apartment": 12,
    "room-for-students": 80,
    "student-housing": 127,
    "studio-for-rent": 32,
    "studio-with-study-space": 6,
    "unfurnished-apartment": 63,
    "unfurnished-house": 7,
    "unfurnished-room": 64,
    "unfurnished-studio": 22
  },
  "utrecht-province": {
    "1-bedroom-apartment": 41,
    "2-bedroom-apartment": 73,
    "3-bedroom-apartment": 20,
    "3-bedroom-house": 18,
    "apartment-with-balcony": 65,
    "apartment-with-elevator": 34,
    "apartment-with-garden": 8,
    "apartment-with-laundry": 6,
    "apartment-with-private-parking": 40,
    "apartment-with-security": 5,
    "family-house": 39,
    "flat-for-students": 54,
    "furnished-1-bedroom-apartment": 10,
    "furnished-apartment": 40,
    "furnished-house": 20,
    "furnished-house-with-garden": 17,
    "furnished-room": 45,
    "furnished-studio": 15,
    "green-energy-apartment": 81,
    "green-energy-house": 18,
    "green-energy-room": 18,
    "green-energy-studio": 10,
    "house-for-rent": 47,
    "house-with-garden": 33,
    "house-with-private-parking": 9,
    "pet-friendly-apartment": 5,
    "pet-friendly-house": 5,
    "renovated-apartment": 12,
    "room-for-students": 112,
    "student-housing": 170,
    "studio-for-rent": 41,
    "studio-with-balcony": 5,
    "studio-with-garden": 7,
    "studio-with-laundry": 5,
    "studio-with-study-space": 6,
    "unfurnished-apartment": 99,
    "unfurnished-house": 27,
    "unfurnished-room": 92,
    "unfurnished-studio": 26
  },
  "venlo": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 6,
    "furnished-room": 5,
    "room-for-students": 9,
    "student-housing": 9,
    "unfurnished-apartment": 7
  },
  "vlissingen": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 5,
    "room-for-students": 5,
    "student-housing": 5,
    "unfurnished-apartment": 6
  },
  "wagen-noordwest": {
    "furnished-room": 5,
    "room-for-students": 12,
    "student-housing": 12,
    "unfurnished-room": 7
  },
  "wageningen": {
    "flat-for-students": 6,
    "furnished-room": 22,
    "green-energy-room": 8,
    "room-for-students": 50,
    "student-housing": 56,
    "studio-for-rent": 5,
    "unfurnished-room": 28,
    "unfurnished-studio": 5
  },
  "wassenaar": {
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 6,
    "family-house": 5,
    "green-energy-apartment": 9,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 10,
    "unfurnished-house": 5
  },
  "weesp-binnenstad": {
    "1-bedroom-apartment": 19,
    "2-bedroom-apartment": 37,
    "3-bedroom-apartment": 14,
    "apartment-with-balcony": 45,
    "apartment-with-elevator": 12,
    "apartment-with-garden": 12,
    "apartment-with-private-parking": 9,
    "flat-for-students": 18,
    "furnished-1-bedroom-apartment": 17,
    "furnished-apartment": 40,
    "furnished-room": 14,
    "furnished-studio": 5,
    "green-energy-apartment": 41,
    "green-energy-room": 5,
    "green-energy-studio": 5,
    "renovated-apartment": 6,
    "room-for-students": 10,
    "student-housing": 28,
    "studio-for-rent": 6,
    "unfurnished-apartment": 36
  },
  "zaanstad": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 20,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 10,
    "apartment-with-private-parking": 9,
    "family-house": 6,
    "furnished-apartment": 5,
    "green-energy-apartment": 12,
    "house-for-rent": 8,
    "newly-built-apartment": 6,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-apartment": 20,
    "unfurnished-house": 6
  },
  "zeeland": {
    "1-bedroom-apartment": 15,
    "1-bedroom-house": 6,
    "2-bedroom-apartment": 24,
    "2-bedroom-house": 9,
    "3-bedroom-house": 18,
    "apartment-with-balcony": 30,
    "apartment-with-elevator": 22,
    "apartment-with-garden": 5,
    "family-house": 27,
    "furnished-apartment": 7,
    "furnished-house": 6,
    "green-energy-apartment": 30,
    "green-energy-house": 19,
    "house-for-rent": 33,
    "house-with-garden": 28,
    "room-for-students": 6,
    "student-housing": 9,
    "unfurnished-apartment": 36,
    "unfurnished-house": 27
  },
  "zeist": {
    "room-for-students": 11,
    "student-housing": 16,
    "unfurnished-room": 10
  },
  "zoetermeer": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 11,
    "3-bedroom-house": 8,
    "apartment-with-balcony": 21,
    "apartment-with-elevator": 19,
    "apartment-with-laundry": 5,
    "apartment-with-security": 7,
    "family-house": 11,
    "green-energy-apartment": 19,
    "green-energy-house": 8,
    "house-for-rent": 11,
    "house-with-garden": 11,
    "renovated-apartment": 5,
    "unfurnished-apartment": 30,
    "unfurnished-house": 10
  },
  "zuid-holland": {
    "1-bedroom-apartment": 328,
    "1-bedroom-house": 8,
    "2-bedroom-apartment": 457,
    "2-bedroom-house": 15,
    "3-bedroom-apartment": 148,
    "3-bedroom-house": 78,
    "4-bedroom-apartment": 28,
    "apartment-with-balcony": 582,
    "apartment-with-elevator": 346,
    "apartment-with-garden": 94,
    "apartment-with-laundry": 62,
    "apartment-with-private-parking": 127,
    "apartment-with-security": 81,
    "family-house": 140,
    "flat-for-students": 215,
    "furnished-1-bedroom-apartment": 97,
    "furnished-apartment": 297,
    "furnished-house": 43,
    "furnished-house-with-garden": 34,
    "furnished-room": 157,
    "furnished-studio": 54,
    "green-energy-apartment": 548,
    "green-energy-house": 87,
    "green-energy-room": 66,
    "green-energy-studio": 65,
    "house-for-rent": 151,
    "house-with-garden": 132,
    "house-with-private-parking": 29,
    "newly-built-apartment": 24,
    "pet-friendly-apartment": 40,
    "pet-friendly-house": 9,
    "renovated-apartment": 128,
    "renovated-house": 17,
    "room-for-students": 246,
    "room-with-laundry": 38,
    "student-housing": 471,
    "studio-for-rent": 127,
    "studio-with-balcony": 10,
    "studio-with-laundry": 41,
    "studio-with-study-space": 14,
    "unfurnished-apartment": 719,
    "unfurnished-house": 108,
    "unfurnished-room": 122,
    "unfurnished-studio": 73
  },
  "zuid-noordwijk": {
    "3-bedroom-house": 5,
    "family-house": 5,
    "house-for-rent": 5
  },
  "zuid-rijswijk": {
    "1-bedroom-apartment": 8,
    "2-bedroom-apartment": 13,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 22,
    "apartment-with-elevator": 15,
    "apartment-with-private-parking": 5,
    "green-energy-apartment": 15,
    "renovated-apartment": 5,
    "unfurnished-apartment": 27
  },
  "zuidplein": {
    "2-bedroom-apartment": 5,
    "unfurnished-apartment": 6
  },
  "zutphen": {
    "2-bedroom-apartment": 5,
    "2-bedroom-house": 5,
    "family-house": 8,
    "house-for-rent": 8,
    "house-with-garden": 8,
    "unfurnished-apartment": 6,
    "unfurnished-house": 8
  }
};